module.exports = __webpack_public_path__ + "img/icon_delete.5b1e18c7.png";